import { CSSProperties } from 'react';

interface Props {
  width?: string;
  height?: string;
  style?: CSSProperties;
}

const Icon = ({ width, height, style }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || '24'}
      height={height || '20'}
      viewBox="0 0 24 20"
      style={style}
    >
      \
      <g fill="none" fillRule="evenodd">
        \
        <path
          stroke="#B7BEC8"
          strokeWidth="1.2"
          d="M18.39 4.798c-.329 0-.657.036-.979.107C16.384 2.49 13.987.88 11.393.88 8.156.88 5.465 3.194 4.93 6.407h-.023c-2.116 0-3.837 1.747-3.837 3.895 0 2.147 1.721 3.895 3.837 3.895H18.39c2.553 0 4.63-2.109 4.63-4.7 0-2.59-2.077-4.699-4.63-4.699z"
        />
        \
        <g stroke="#5B8BF7" strokeLinecap="round">
          \
          <path d="M5.833 17.125L7 19.145M10.5 17.125l1.167 2.02M15.167 17.125l1.166 2.02M19.833 17.125L21 19.145" />
          \
        </g>
        \
      </g>
      \
    </svg>
  );
};

export default Icon;
